import { render } from "./tehilimText.vue?vue&type=template&id=4ea03bc0"
import script from "./tehilimText.vue?vue&type=script&lang=js"
export * from "./tehilimText.vue?vue&type=script&lang=js"

import "./tehilimText.vue?vue&type=style&index=0&id=4ea03bc0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__